/**
 * Human-friendly labels for advanced-filter operator/type keys.
 *
 * The raw keys (`gte`, `notNull`, `dateRange`, …) are what the filter engine
 * stores and what the API translates. They are NOT presentable to users —
 * "gte" or "[object Object]" leaking into a chip is exactly the kind of UI bug
 * this module exists to prevent. Both the field inputs and the active-filter
 * chips read their display text from here so the vocabulary stays consistent.
 */

const FILTER_TYPE_LABELS: Record<string, string> = {
  contains: "Contains",
  exact: "Any of",
  eq: "Equals",
  neq: "Not equal",
  startsWith: "Starts with",
  endsWith: "Ends with",
  notNull: "Has value",
  multiSelect: "Multiple",
  dateRange: "Between",
  timeRange: "Between",
  numberRange: "Between",
  range: "Between",
  gt: "Greater than",
  gte: "At least",
  lt: "Less than",
  lte: "At most",
  "company-select": "Company",
  "client-select": "Client",
  "user-select": "User",
};

/**
 * Map a stored filter type to a short, human label for display.
 * Unknown keys fall back to the raw key so nothing silently disappears.
 */
export function getFilterTypeLabel(type: string | undefined | null): string {
  if (!type) return "";
  return FILTER_TYPE_LABELS[type] ?? type;
}
